import "./bootstrap";
import { createApp, defineAsyncComponent } from "vue";
import App from "./layouts/app.vue";
import vuetify from "./vuetify";

// Above-fold components (load eagerly)
import About from "@/layouts/about.vue";
import Slider from "@/layouts/slider.vue";

// Below-fold components (lazy-loaded for performance)
const Services = defineAsyncComponent(() => import("@/layouts/services.vue"));
const Appointment = defineAsyncComponent(() => import("@/layouts/make_appointment.vue"));
const Team = defineAsyncComponent(() => import("@/layouts/team.vue"));
const Youtube = defineAsyncComponent(() => import("@/layouts/youtube.vue"));
const Gallery = defineAsyncComponent(() => import("@/layouts/gallery.vue"));


const vueApp = createApp({
    components: {
        Appointment,
        Team,
        Youtube,
        Services,
        About,
        //Carousel,
        Gallery,
        Slider,
        //Related,
    }
})

    .use(vuetify);
// Provide the locale URL to the entire app if needed
if (window.locale_url) {
    vueApp.provide('localeUrl', window.locale_url);
}
if (window.lang) {
    vueApp.provide('lang', window.lang);
}

// Provide translation data to the entire app if needed
if (window.myTranslate) {
    vueApp.provide('myTranslate', window.myTranslate);
}

// Mount the Vue application to the #app element
const appElement = document.getElementById('app');
if (appElement) {
    vueApp.mount("#app");
} else {
    console.error('Element with id "app" not found.');
}
